import { Box, Stack, Typography } from '@mui/material';
import { androidTecnozapVersion } from '../../controller/android-interface-controller';

export default function AppVersionTecnozap() {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mr: 1 }}>
        <Typography variant="caption" color="textDisabled">
          TECNOZAP
        </Typography>
        <Typography variant="caption" color="textDisabled">
          |
        </Typography>
        <Typography variant="caption" color="textDisabled">
          {`v${process.env.REACT_APP_VERSION}`}
          {window.Android && ` | ${androidTecnozapVersion()}`}
        </Typography>
      </Stack>
    </Box>
  );
}
